// @ts-strict-ignore
import { typedWindow } from './types'

export function setCustomerId(id: number) {
  if (typedWindow.ScarabQueue) {
    typedWindow.ScarabQueue.push(['setCustomerId', id.toString()])
  }
}
